var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"PLATFORM ADMINISTRATION","title":"SMS","description":"Manage schools, school subjects, platform metrics and notifications.","count-label":"admin tools"}},[_c('Submenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }